import clsx from 'clsx';

/**
 * Conditional className helper.
 *
 *   cn('px-4', isActive && 'bg-brand-soft', className)
 */
export function cn(...inputs) {
  return clsx(inputs);
}

export default cn;
